import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

import { sensitiveEnv } from "../../config/sensitiveEnv";

/**
 * Initialize Datadog RUM and Logs
 */
export const initializeDatadogRUM = (): void => {
  try {
    const applicationId = sensitiveEnv.datadogAppId;
    const clientToken = sensitiveEnv.datadogClientToken;
    const datadogSessionSampleRate = Number(
      process.env.REACT_APP_DATADOG_SESSION_SAMPLE_RATE ?? 0
    );
    const datadogSessionReplaySampleRate = Number(
      process.env.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE ?? 0
    );
    const ApplicationVersion = process.env.REACT_APP_VERSION ?? "1.0.0";

    if (datadogRum.getInternalContext?.()) return;
    if (applicationId && clientToken && datadogSessionSampleRate > 0) {
      // Initialize Datadog RUM
      datadogRum.init({
        applicationId,
        clientToken,
        site: "datadoghq.eu",
        service: "cropwise-trialing",
        env: process.env.REACT_APP_ENV ?? "uat",
        version: ApplicationVersion,
        sessionSampleRate: datadogSessionSampleRate,
        sessionReplaySampleRate: datadogSessionReplaySampleRate,
        trackUserInteractions: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
      });

      // Initialize Datadog Logs
      datadogLogs.init({
        clientToken,
        site: "datadoghq.eu",
        forwardErrorsToLogs: true,
        sessionSampleRate: datadogSessionSampleRate,
      });

      // Enable session replay
      datadogRum.startSessionReplayRecording({ force: true });
    }
  } catch (error) {
    console.error("Failed to initialize Datadog RUM:", error);
  }
};

/**
 * Add user attributes to Datadog RUM
 *
 * @param userId
 * @param email
 */
export const addUserAttributesToDatadogRUM = (
  userId: string,
  email: string
): void => {
  datadogRum.setUser({ id: userId, email });
};

/**
 * Reset user attributes in Datadog RUM
 */
export const resetUserAttributesInDatadogRUM = (): void => {
  try {
    // Preferred API (Datadog Browser RUM v6+)
    datadogRum.clearUser?.();
  } catch (error) {
    console.error("Failed to clear Datadog RUM user:", error);
  }

  // Fallback for older SDKs / defensive cleanup
  datadogRum.setUser({}); // NOSONAR
};
